import React, { useState } from 'react';
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";

const Template = () => {
  
  // This is not in use
  const [doc_num, setDocNum] = useState(0);  
  const MyModal = () => {
    return (
      <>
        <div className={"modal fade"} id="myModal">
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
            
              <div className="modal-header">
                <h3 className="modal-title">Required Documents</h3>
                <button type="button" className="close" data-dismiss="modal">×</button>
              </div>
              
              <div className="modal-body">
              {doc_num == 1 && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/app/templates/2023-24/CDRI-Fellowship-programe_Utilization-Certificate-First-Instalment.docx" },
                      // { uri: require("./Docs/Fellowship programe - Utilization Certificate.docx") }, // Local File
                    ]
                  } 
                />
              }
              {doc_num == 2 && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/app/templates/2023-24/CDRI-Fellowship-Programme-Utilization-Certificate_Second-Instalment-Template.docx" },
                      // { uri: require("./Docs/Fellowship programe - Utilization Certificate.docx") }, // Local File
                    ]
                  } 
                />
              }
              {doc_num == 3 && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/app/templates/Form 10F.pdf" },
                      // { uri: require("./Docs/Form 10F.pdf") }, // Local File
                    ]
                  } 
                />
              }
              {doc_num == 4 && 
                <DocViewer
                  pluginRenderers={DocViewerRenderers} 
                  documents={
                    [
                      { uri: process.env.REACT_APP_PUBLIC_URL+"/app/templates/No PE Certificate.docx" },
                      // { uri: require("./Docs/No PE Certificate.docx") }, // Local File
                    ]
                  } 
                />
              }
              </div>
              
              <div className="modal-footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
              </div>
              
            </div>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="card border-danger">
        <div className="card-header bg-light p-2 border-danger" style={{"borderTop": "3px solid"}}><h6>Required Documents</h6></div>
        <div className="card-body">
          <div className='row'>
            <div className='col-md-4'>
              <div className="dropdown">
                <button type="button" className="btn btn-danger btn-block dropdown-toggle" data-toggle="dropdown">
                Utilization Certificate
                </button>
                <div className="dropdown-menu">
                  <a className="dropdown-item" href={process.env.REACT_APP_PUBLIC_URL+"/app/templates/2023-24/CDRI-Fellowship-programe_Utilization-Certificate-First-Instalment.docx"} >First Instalment</a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href={process.env.REACT_APP_PUBLIC_URL+"/app/templates/2023-24/CDRI-Fellowship-Programme-Utilization-Certificate_Second-Instalment-Template.docx"} >Second Instalment</a>
                </div>
              </div>          
            </div>
            <div className='col-md-4'>
              {/* <button data-toggle="modal" data-target="#myModal" onClick={() => setDocNum(3)} className="btn btn-danger btn-block">
                Form 10F
              </button> */}
              {/* <a href={process.env.REACT_APP_PUBLIC_URL+"/app/templates/Form 10F.pdf"} target={'_blank'} className="btn btn-danger btn-block">Form 10F</a> */}
            </div>
            <div className='col-md-4'>
              {/* <button data-toggle="modal" data-target="#myModal" onClick={() => setDocNum(4)} className="btn btn-danger btn-block">
                No PE Certificate
              </button> */}
              {/* <a href={process.env.REACT_APP_PUBLIC_URL+"/app/templates/No PE Certificate.docx"} className="btn btn-danger btn-block">No PE Certificate</a> */}
            </div>
          </div>
        </div>
      </div>
      <MyModal />
    </>
  );
};

export default Template;